module.exports = __webpack_public_path__ + "static/img/water-right.181ee072.png";